// frontend/src/components/BottomNav.jsx
import { Home, Zap, History, Telescope, Star, Dices, Crown } from 'lucide-react';
import { colors, fontFamily } from '../theme';

const TABS = [
  { key: 'home', label: 'Home', icon: Home, requiresSportsbook: true },
  { key: 'live', label: 'Live', icon: Zap, requiresSportsbook: true },
  { key: 'futures', label: 'Futures', icon: Telescope, requiresSportsbook: true },
  { key: 'casino', label: 'Casino', icon: Dices, requiresCasinoAccess: true },
  { key: 'leaderboard', label: 'Leaderboard', icon: Crown, requiresLeaderboardAccess: true, requiresSportsbook: true },
  { key: 'favorites', label: 'Favorites', icon: Star, requiresSportsbook: true },
  { key: 'mybets', label: 'My Bets', icon: History },
];

// Tabs a customer keeps when the book has turned their sportsbook access off —
// everything else in TABS is hidden.
export const SPORTSBOOK_OFF_TABS = TABS.filter(t => !t.requiresSportsbook).map(t => t.key);

export default function BottomNav({ activeTab, onTabChange, user }) {
  const sportsbookOn = user?.sportsbook_access !== false;
  const tabs = TABS.filter(t =>
    (!t.requiresSportsbook || sportsbookOn) &&
    (!t.requiresCasinoAccess || user?.casino_access) &&
    (!t.requiresLeaderboardAccess || user?.leaderboard_enabled)
  );

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 flex items-stretch z-40"
      style={{ background: 'rgba(10,4,11,0.92)', backdropFilter: 'blur(12px)', fontFamily }}
    >
      {tabs.map(({ key, label, icon: Icon }) => {
        const isActive = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onTabChange(key)}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2"
            style={{ color: isActive ? colors.gold : colors.textPrimary }}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
